import { CategoryWithId } from "../interfaces/ICategories";
import { ContestWithId } from "../interfaces/IContests";
import { useMemo } from "react";

/**
 * Hook sprawdzający czy można uploadować muzykę dla danej kategorii
 * 
 * @param category - Kategoria do sprawdzenia
 * @param contest - Opcjonalny turniej (sprawdza flagę blokady uploadu)
 * @returns Obiekt z flagą canUploadMusic
 */
export function useMusicUploadPermission(
  category: CategoryWithId | null | undefined,
  contest?: ContestWithId | null
) {
  const canUploadMusic = useMemo(() => {
    if (!category) {
      return false;
    }
    
    // Sprawdź czy turniej ma zablokowany upload
    if (contest?.musicUploadLocked === true) {
      return false;
    }
    
    return category.allowCustomMusic === true;
  }, [category?.allowCustomMusic, contest?.musicUploadLocked]);

  return {
    canUploadMusic,
  };
}
